import store from "@/store/store"

export default [
    {
        text: '#',
        value: 'id',
    },
    {
        text: 'Producto',
        fieldType: 'computed',
        value: ({ name }) => {
            return name
        },
    },
    {
        text: 'Alias',
        fieldType: 'computed',
        value: ({ alias_name }) => {
            return alias_name
        },
    },
    {
        text: 'Tipo',
        fieldType: 'computed',
        value: ({ wh_item_id, wh_pack_id, wh_packing_id, wh_promo_id }) => {
            //
            if (wh_item_id) return 'ITEM'
            if (wh_pack_id) return 'PACK'
            if (wh_packing_id) return 'PACKING'
            if (wh_promo_id) return 'PROMO'
            //
            return 'Desconocido'
        },
    },
    {
        text: 'Código Prov',
        fieldType: 'computed',
        value: ({ last_provider_code }) => {
            return last_provider_code
        },
    },

    // },
    // {
    //     text: 'Precio Compra',
    //     value: 'last_net_price',

    // },
    {
        text: 'Stock',
        value: ({ stocks }) => {
            return stocks.reduce((stock, branch) => {
                //
                //console.log({ store: store.state.AuthModule.user.hr_employee.g_branch_office_id })
                //
                if (branch.g_branch_office_id == store.state.AuthModule.user.hr_employee.g_branch_office_id) {
                    return branch.wh_warehouses.reduce((stock, warehouse) => {
                        return warehouse.logical_stock + stock
                    }, 0)
                }
                //
                return stock
            }, 0)
        },
    },
]
